const TransferOrders = {
  el: {
    root: document.querySelector<HTMLElement>('.transfer-orders'),
    navItems: document.querySelectorAll<HTMLElement>('.transfer-orders__nav-link'),
    items: document.querySelectorAll<HTMLElement>('.transferorder-item__wrap'),
    header: document.querySelector<HTMLElement>('.header'),
  },
  init() {
    if (this.el.root) {
      this.handleNav()
    }
  },
  handleNav() {
    Array.prototype.forEach.call(this.el.navItems, (item: HTMLButtonElement) => {
      
      item.addEventListener('click', (e: Event & {target: HTMLButtonElement}) => {        
        const number = e.target.dataset.item;
        const el = this.el.root.querySelector<HTMLElement>(`.transferorder-item__wrap[data-item="${number}"]`)

        this.removeActive()

        e.target.classList.add('active')

        if (el) {
          this.showElement(el)
        }
        else {
          console.log('showall');
          
          this.showAll()
        }
      })
    })
  },
  showElement(element: HTMLElement) {
    element.style.display = 'block'
  },
  removeActive() {
    Array.prototype.forEach.call(this.el.navItems, item => {
      item.classList.remove('active')
    })
    Array.prototype.forEach.call(this.el.items, (item: HTMLElement) => {
      item.style.display = 'none';
    })
  },
  showAll() {
    Array.prototype.forEach.call(this.el.items, (item: HTMLElement) => {
      item.style.display = 'block'
    })
  },
}

export default TransferOrders
